import React, { ReactElement } from 'react';
import { Logo } from './Logo';
import styled from 'styled-components';
import { useTermsAndConditions } from '../../hooks/useTermsAndConditions';

const BrandWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

const FooterLogoWrapper = styled.div`
  align-items: start;
  display: flex;
  flex-direction: column;
  width: 8rem;

  @media only screen and (min-width: 1024px) {
    width: 10rem;
  }
`;

const FooterLogoText = styled.div`
  color: #575757;
  font-size: 10px;
  margin-bottom: 0.1rem;
`;

const LinkText = styled.a`
  color: #575757;
  display: block;
  font-size: 10px;
  margin-top: 0.1rem;
  text-decoration: none;

  &:hover {
    color: rgb(46, 46, 46);
    text-decoration: none;
  }
`;

const FooterLinksWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

const LogoLink = styled.a`
  width: 100%;
`;

export const FooterLogo = (): ReactElement => {
  const currentYear = new Date().getFullYear();
  const { data: termsAndConditions } = useTermsAndConditions();

  return (
    <BrandWrapper>
      <FooterLogoWrapper>
        <FooterLogoText>Powered By:</FooterLogoText>
        <LogoLink href="https://www.deckard.com" target="_blank" rel="noreferrer">
          <Logo />
        </LogoLink>
      </FooterLogoWrapper>

      <FooterLinksWrapper>
        <LinkText
          href="https://www.deckard.com"
          target="_blank"
          data-testid="copyrightlink"
          rel="noreferrer"
        >
          &copy; {currentYear} deckard.com
        </LinkText>
        <LinkText
          href="https://app.termly.io/policy-viewer/policy.html?policyUUID=b6219f58-5bc6-4d88-8595-89887d2e0900"
          target="_blank"
          rel="noreferrer"
        >
          Privacy Policy
        </LinkText>
        {termsAndConditions && (
          <LinkText href={termsAndConditions.pdfLink} target="_blank" rel="noreferrer">
            Terms of Service
          </LinkText>
        )}
      </FooterLinksWrapper>
    </BrandWrapper>
  );
};
